import { DisclosureLabel } from '@insightai/ai-patterns'
import { StatusPill } from '@insightai/ui'
import { MarketingPage, Section } from './MarketingPage'

export function MethodologyPage() {
  return (
    <MarketingPage
      title="Methodology"
      lede="The platform is opinionated about research method on purpose. These are the frameworks it applies, and where a human stays in the loop."
    >
      <Section heading="Problem structuring">
        <p className="text-body-sm text-text-secondary">
          Briefs are framed with TOSCA — Trouble, Owner, Success criteria, Constraints, Actors — then
          decomposed into a MECE issue tree or an issue pyramid. A null-hypothesis branch is always
          generated, so a favourable answer is never the only one tested.
        </p>
        <div className="flex flex-wrap gap-2">
          <StatusPill tone="verified" label="Ready — 75 and above" size="sm" />
          <StatusPill tone="warning" label="Needs refinement — 50 to 74" size="sm" />
          <StatusPill tone="critical" label="Too vague — below 50" size="sm" />
        </div>
      </Section>

      <Section heading="Measurement & scaling">
        <p className="text-body-sm text-text-secondary">
          Measurement level (nominal, ordinal, interval, ratio) is enforced before analysis is chosen.
          Comparative scaling — paired comparison, rank order, constant sum — and non-comparative
          scaling — continuous rating, Likert 3/5/7/10-point, semantic differential, Stapel — are
          offered with an explicit recommendation and an override at each step.
        </p>
      </Section>

      <Section heading="Questionnaire design intelligence">
        <p className="text-body-sm text-text-secondary">
          Every question is audited against Tourangeau's four cognitive stages — comprehension,
          retrieval, judgment, response formulation — plus eleven wording dimensions covering
          double-barrelled, leading and ambiguous phrasing. Sensitive topics get mitigation
          techniques with a plain-language rationale.
        </p>
      </Section>

      <Section id="governance" heading="AI governance">
        <p className="text-body-sm text-text-secondary">
          Every AI-generated output carries the model and version that produced it, an explanation
          citing the methodological principle behind it, and an override control. Overrides require a
          reason and are logged. Reports carry a disclosure label on every page:
        </p>
        <DisclosureLabel kind="aiDisclosure" className="w-fit" />
        <p className="text-body-sm text-text-secondary">
          Simulated persona output and scenario interpretations are labelled separately, because
          neither is a research finding:
        </p>
        <div className="flex flex-col gap-2">
          <DisclosureLabel kind="simulatedResponses" className="w-fit" />
          <DisclosureLabel kind="scenarioInterpretation" className="w-fit" />
        </div>
      </Section>
    </MarketingPage>
  )
}
